module.exports = __webpack_public_path__ + "img/logo-mobile.8f9a9945.png";